<template>
  <!-- todo translate-->
  <a href="#" class="bg-white hover:bg-blue-50 rounded-md shadow-md p-3 flex">
    <div class="w-full" style="width: 100px">
      <img src="https://cdn.aboutstatic.com/file/images/f0d6e68c476c8583d73d492b6fb12333.jpg?width=2000&quality=75&bg=F4F4F5" alt="" />
    </div>
    <div class="text-sm pl-5 space-y-1 flex-grow">
      <div class="flex justify-between">
        <h3 class="font-bold">Tričko</h3>
        <span>
                      <aw-icon icon="cart" class="w-5 h-5 " />
                    </span>
      </div>
      <div class="text-gray-400">Czech / Prague / New / Version 4</div>
      <div>
        <table class="Table table-fixed !w-auto">
          <tr>
            <td class="!border-0 py-2 px-3 pl-0 text-gray-400  whitespace-nowrap">
              Kód produktu: EA32887
            </td>
            <td class="!border-0 py-2 px-3 text-gray-400 whitespace-nowrap">
              Cena: 1149 Kč
            </td>
          </tr>
        </table>
      </div>
    </div>
  </a>
</template>